<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 설비종류 -->
          <c-select
            type="search"
            :comboItems="typeItems"
            itemText="codeName"
            itemValue="code"
            name="machineryTypeCd"
            label="유형"
            v-model="searchParam.machineryTypeCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            :range="true"
            label="점검기간"
            defaultStart="-6M"
            defaultEnd="6M"
            name="period"
            v-model="period"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 진행단계 -->
          <c-select
            :comboItems="statusItems"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="completeFlag"
            label="진행단계"
            v-model="searchParam.completeFlag"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    
    <q-table
      grid
      title=""
      :data="grid.data"
      :columns="grid.columns"
      hide-header
      hide-bottom
      :rows-per-page-options="[0]"
      virtual-scroll
    >
      <template v-slot:top-right>
        <q-btn-group outline >
          <c-btn label="등록" :editable="editable" icon="add" @btnClicked="onItemClick" />
        </q-btn-group>
      </template>
      <template v-slot:item="props">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3">
          <q-card class="mobileTableCardLayer" @click="linkClick(null,props.row)">
            <q-card-section horizontal class="bg-grey-2">
              <q-card-section class="q-pt-xs">
                <div class="text-grid-title q-mt-sm q-mb-xs">{{ props.row.focusName }}</div>
              </q-card-section>
            </q-card-section>
            <q-card-section class="grid-card-etc">
              <div class="text-grid-etc-title">
                유형 :
              </div>
              <div class="text-grid-etc">
                {{ props.row.machineryTypeName }}
              </div>
              <br>
              <div class="text-grid-etc-title">
                점검일 :
              </div>
              <div class="text-grid-etc">
                {{ props.row.inspectionDate }}
              </div>
              <div :class="['text-grid-etc', getColorStatus(props.row.completeFlag)]">
                {{ props.row.completeFlagName }}
              </div>
            </q-card-section>
          </q-card>
        </div>
      </template>
    </q-table>
    <!-- <c-table
      ref="table"
      title="중점점검 결과 목록"
      :columns="grid.columns"
      :merge="grid.merge"
      :data="grid.data"
      rowKey="focusInspectionId"
      @linkClick="linkClick"
    >
      <template slot="table-button">
        <div>
          <q-btn-group>
            <c-btn label="신규등록" :editable="editable" icon="add" @btnClicked="onItemClick" />
            <c-btn label="검색" icon="search" @btnClicked="getList" />
          </q-btn-group>
        </div>
      </template>
    </c-table> -->
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: "hazard-focus-inspection",
  data() {
    return {
      grid: {
        merge: [
          { index: 0, colName: 'mergeGroup' },
          { index: 1, colName: 'mergeGroup' },
          { index: 2, colName: 'mergeGroup' },
        ],
        columns: [
          {
            name: "plantName",
            field: "plantName",
            label: "사업장",
            style: 'width:100px', 
            align: "center",
            sortable: true,
          },
          {
            name: "machineryTypeName",
            field: "machineryTypeName",
            label: "유형",
            style: 'width:100px', 
            align: "center",
            sortable: true,
          },
          {
            name: "focusName",
            field: "focusName",
            label: "점검명",
            style: 'width:300px', 
            align: "left",
            sortable: true,
            type: "link",
          },
           {
            name: "emplacementPlace",
            field: "emplacementPlace",
            label: "설비위치",
            style: 'width:200px', 
            align: "left",
            sortable: true,
          },
          {
            name: "machineryClassification",
            field: "machineryClassification",
            label: "설비종류",
            style: 'width:100px', 
            align: "center",
            sortable: true,
          },
          {
            name: "machineryName",
            field: "machineryName",
            label: "형식(규격)",
            style: 'width:200px', 
            align: "left",
            sortable: true,
          },
          {
            name: "inspectionDate",
            field: "inspectionDate",
            label: "점검일",
            style: 'width:120px', 
            align: "center",
            sortable: true,
          },
          {
            name: "inspectionUserName",
            field: "inspectionUserName",
            label: "점검자",
            style: 'width:100px', 
            align: "center",
            sortable: true,
          },
          {
            name: "completeFlagName",
            field: "completeFlagName",
            label: "완료여부",
            style: 'width:120px', 
            align: "center",
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: null,
        startYmd: '',
        endYmd: '',
        completeFlag: null,
        machineryTypeCd: null,
      },
      period: [],
      typeItems: [],
      editable: true,
      listUrl: '',
      popupOptions: {
        isFull: true,
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
      statusItems: [
        { code: "N", codeName: "점검중" },
        { code: "Y", codeName: "점검완료" },
      ],
      isResult: false,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  beforeRouteLeave(to, from, next) { // history.back 일경우 팝업이라면 팝업을 닫자
    if (this.popupOptions.visible) {
      this.closePopup();
      next(false);
    } else {
      next();
    }
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      // url setting
      this.listUrl = selectConfig.sop.hhm.hazard.focus.info.list.url;
      // list setting
      this.getTypeDetail();
      this.getList();
    },
    getList() {
      if (this.period) {
        this.searchParam.startYmd = this.period[0];
        this.searchParam.endYmd = this.period[1];
      } else {
        this.searchParam.startYmd = '';
        this.searchParam.endYmd = '';
      }
      // 전체조회
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    getColorStatus(cd) {
      var cls = '';

      if (!cd) cd = 'N';
      switch(cd) {
        case 'N': // 점검중
          cls = 'text-primary';
          break;
        case 'Y': // 점검완료
          cls = 'text-positive';
          break;
      }
      return cls;
    },
    getTypeDetail() {
      this.$http.url = this.$format(selectConfig.sys.code.mst.list.attr.url, 'HHM_TYPE_CD', 'N');
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.typeItems = _result.data;
      },
      () => {
      });
    },
    /* eslint-disable no-unused-vars */ 
    linkClick(evt, row) {
      this.popupOptions.title = "중점점검 결과 상세"; // 중점점검 결과 상세
      this.popupOptions.param = {
        focusInspectionId: row ? row.focusInspectionId : '',
      };
      this.popupOptions.target = () =>
        import(`${"./hazardFocusInspectionDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.height = '300px';
      this.popupOptions.isFull = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup(type) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
    onItemClick() {
      this.linkClick(null)
    },
  },
};
</script>